import axios from 'axios';

export const endpoints = {
    getAuditLogs: () => 'auditLog/paged',
    getAuditAdmins: () => 'auditLog/admins'
};

export const getAuditAdmins = () => axios.get(endpoints.getAuditAdmins());

export const getAuditLogs = params =>
    axios.get(endpoints.getAuditLogs(), { params: { page: 1, count: 50, sort: 'date', asc: false, ...params } });
